import { render } from "./StudentSessionsManagement.vue?vue&type=template&id=d981af9a&scoped=true"
import script from "./StudentSessionsManagement.vue?vue&type=script&lang=js"
export * from "./StudentSessionsManagement.vue?vue&type=script&lang=js"

import "./StudentSessionsManagement.vue?vue&type=style&index=0&id=d981af9a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d981af9a"]])

export default __exports__